// extracted by mini-css-extract-plugin
export var button = "_cd-4";
export var hasDarkBackground = "_cd-7";
export var hasLightBackground = "_cd-6";
export var iconWrapper = "_cd-0";
export var large = "_cd-2";
export var medium = "_cd-1";
export var small = "_cd-5";
export var xsmall = "_cd-3";